import React from 'react';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
export function ContractorsTotalsRow(_ref) {
  let {
    claim
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("td", {
    className: "col-form-label",
    md: 2
  }, "Totals"), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    className: "p-1",
    md: 1
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    disabled: true,
    name: "contractor_expense_totals",
    object: claim,
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    disabled: true,
    name: "contractor_qre_totals",
    object: claim,
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null)));
}